import {newModalStore} from "@/store/helpers/modal-helper";

let confirmationModal = Object.assign({namespaced: true},  newModalStore())

export default confirmationModal
